<div>
  <span class="text-color-secondary">{{ 'LABELS.CUSTOMER_NAME' | translate }}:</span>
  {{ customerName }}
</div>

<div class="mt-3">
  <p-fieldset [legend]="'LABELS.OFFLINE_CUSTOMER_KEY' | translate" class="clean-fieldset text-color-secondary adapt">
    <div class="flex align-items-center gap-2">

      <button
        pButton
        class="p-button-rounded p-button-text p-button-plain"
        [class.p-button-secondary]="!copied"
        [class.p-button-success]="copied"
        [label]="(copied ? 'LABELS.COPIED' : '') | translate"
        [icon]="copied ? 'fa-solid fa-circle-check' : 'fa-solid fa-copy'"
        [pTooltip]="(copied ? '' : 'LABELS.COPY') | translate"
        (click)="onCopy()"
      ></button>
      <button pButton class="p-button-rounded p-button-text p-button-plain" icon="fa-solid fa-download" (click)="downloadKeyFile()" [pTooltip]="'BUTTONS.DOWNLOAD_OFFLINE_CUSTOMER_KEY' | translate"></button>
    </div>
  </p-fieldset>
</div>
